module.exports = __webpack_public_path__ + "img/trashline.a08db66a.svg";